import { Inject, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { SearchRepository } from '@core/services/repositories/search.repository';
import { WINDOW } from '../../app.module';
import { isPlatformBrowser } from '@angular/common';
@Injectable({
 providedIn: 'root',
})
export class MapService {
 constructor(
  @Inject(WINDOW) private window: Window,
  @Inject(PLATFORM_ID) private platformId: Object
 ) {}
 private _leafletInstance!: any;
 private mapInstance!: any;
 searchRepo = inject(SearchRepository);

 async initLeafletMap(
  containerId: string,
  lat: number,
  lng: number,
  zoom: number,
  zoomControl = true,
  zoomControlPosition = ''
 ) {
  if (!isPlatformBrowser(this.platformId)) return;

  this._leafletInstance = await import('leaflet');

  const map = this._leafletInstance.map(containerId, {
   center: [lat, lng],
   zoom: zoom,
   zoomControl,
  });

  this._leafletInstance
   .tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; OpenStreetMap contributors',
   })
   .addTo(map);

  if (zoomControlPosition) {
   this._leafletInstance.control
    .zoom({
     position: zoomControlPosition
    })
    .addTo(map);
  }

  this.mapInstance = map;
  return map;
 }

 leafletFitToPoints(coords: [number, number][]): void {
  const bounds = this.leafletInstance.latLngBounds(coords);
  this.mapInstance.fitBounds(bounds, { padding: [50, 50] });
  const customHtmlIcon = this.leafletInstance.divIcon({
   className: 'custom-marker',
   html: `<div class="rounded-full bg-primary-500 w-4 h-4 outline-4 outline outline-primary-500/20"></div>`,
   iconSize: [50, 30],
   iconAnchor: [25, 30],
  });

  coords.forEach((point, i) => {
   const marker = this.leafletInstance
    .marker(point, { icon: customHtmlIcon })
    .addTo(this.mapInstance);
   marker.bindPopup('<p>Salam</p>', {
    minWidth: 70,
    closeButton: false,
    className: 'hotel-map-popup',
   });
  });
 }

 async initNeshanMap(
  containerId: string,
  lat: number,
  lng: number,
  zoom: number,
  apiKey: string
 ): Promise<any> {
  const neshanL = await this.loadNeshanSDK();

  const map = new neshanL.Map(containerId, {
   key: apiKey,
   maptype: 'neshan',
   poi: false,
   traffic: false,
   center: [lat, lng],
   zoom: zoom,
  });

  this.mapInstance = map;
  return map;
 }

 getMapInstance() {
  return this.mapInstance;
 }

 loadNeshanSDK(): Promise<any> {
  return new Promise((resolve, reject) => {
   if ((this.window as any).neshanL) {
    return resolve((this.window as any).neshanL);
   }
   const script = document.createElement('script');
   script.src = 'https://static.neshan.org/sdk/leaflet/v1.9.4/neshan-sdk/v1.0.8/index.js';
   script.onload = () => {
    (this.window as any).neshanL = (this.window as any).L;
    resolve((this.window as any).neshanL);
   };
   script.onerror = reject;
   document.body.appendChild(script);
  });
 }

 get leafletInstance() {
  return this._leafletInstance;
 }
}
